import { Skeleton } from '@/components/ui/skeleton';
import { PendingRegion } from '@/shared/components/PendingRegion';

import { USAGE_PAGE_GAP } from '../usageLayout';

/**
 * The usage page's figures while they load (spec 079 US2).
 *
 * Heights are reserved per card rather than left to a single flexible block, because
 * this page grows downward as each card arrives: the meter, the table, the daily
 * series (spec 232). A placeholder that reserved one tall box would agree with the loaded
 * page only by accident, and the page would still shuffle as the real figures landed.
 * The gap between the blocks is the page's own (`USAGE_PAGE_GAP`), so the two cannot
 * drift apart (spec 079 FR-016).
 *
 * No axes, no bars, no legend — the shape says "figures are coming", and drawing plausible
 * data would be a picture of numbers this page does not have yet (FR-015).
 */
export function UsageSkeleton() {
  return (
    <PendingRegion label="Loading usage" className={USAGE_PAGE_GAP}>
      {/* The spend meter, with its footer line and Token details (spec 231, 232). */}
      <Skeleton className="h-32 w-full rounded-lg" />
      {/* Where it went: one table across the width (spec 225), now second. */}
      <Skeleton className="h-80 w-full rounded-lg" />
      {/* The daily series. */}
      <Skeleton className="h-64 w-full rounded-lg" />
    </PendingRegion>
  );
}
